/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Erp_Invoice_Not_ReadyInputs */

const en_error_inbound_erp_invoice_not_ready = /** @type {(inputs: Error_Inbound_Erp_Invoice_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The supplier invoice cannot go in the invoices file to the ERP yet: see what stops it.`)
};

/**
* | output |
* | --- |
* | "The supplier invoice cannot go in the invoices file to the ERP yet: see what stops it." |
*
* @param {Error_Inbound_Erp_Invoice_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_erp_invoice_not_ready = /** @type {((inputs?: Error_Inbound_Erp_Invoice_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Erp_Invoice_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_erp_invoice_not_ready(inputs)
});